export default __webpack_public_path__ + "static/media/github.fc901f5e.png";